const getCss = (file: string) => require('../stylesheets/' + file + '.less');

// const html = (file: string) => require('../html/' + file + '.html');

// const any = html('pricing');
// console.log(any);

const queryParams: any = () =>
    _.chain(location.search.slice(1).split('&'))
        .map(item => item.split('=')).compact().object().value();

const getAngular = (lib: string) => `https://cdnjs.cloudflare.com/ajax/libs/angular.js/1.6.7/angular-${lib}.min.js`;

export const playerUrl = () => {
    let search = queryParams(),
        version = search.pVer || (location.host.indexOf('nightly') === 0 ? 'nightly' : 'latest'),
        min = options.isProduction,
        dev = !options.isProduction,
        salt = search.pSalt === 'on' ? new Date().getTime() : options.salt;
    if (search.pMin === 'off') min = false;
    if (search.pMin === 'on') min = true;
    if (search.pDev === 'off') dev = false;
    if (search.pDev === 'on') dev = true;

    const url = `https://player${dev ? '-dev' : ''}.animatron.com/${version}/bundle/animatron${min ? '.min' : ''}.js?${salt}`;
    return search.pUrl || url;
};

export const SimpleMDEUrl = 'https://cdn.jsdelivr.net/simplemde/latest/simplemde.min.js';

export const jqueryPaymentLib = [
    'https://cdnjs.cloudflare.com/ajax/libs/jquery/2.2.1/jquery.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/jquery.payment/1.3.2/jquery.payment.min.js'
];

export const masonryLib = 'https://cdnjs.cloudflare.com/ajax/libs/masonry/4.1.0/masonry.pkgd.min.js';

export const flickityLib = 'https://cdnjs.cloudflare.com/ajax/libs/flickity/2.0.10/flickity.pkgd.min.js';

export const twitterWidgetLib = 'https://platform.twitter.com/widgets.js';

export const fbSDKlib = `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.11&appId=${options.social.facebookApiKey}`;

export const linkedinLib = '//platform.linkedin.com/in.js';

export const googleLib = 'https://apis.google.com/js/platform.js';

export const tapfiliateLib = '//static.tapfiliate.com/tapfiliate.js';

export const animatronProject = [
    getCss('projects'),
    getCss('user-popup'),
    getCss('comments')
];

const angularMessages: oc.IModuleConfig = {
    name: 'ngMessages',
    files: [getAngular('messages')]
};

export const datePicker = () => Promise.resolve({
    name: 'datePicker',
    files: ['https://cdn.rawgit.com/g00fy-/angular-datepicker/8c46855bed78ff7f0b523a794c7bdaabb558d081/dist/angular-datepicker.min.js',
        'https://cdn.rawgit.com/g00fy-/angular-datepicker/8c46855bed78ff7f0b523a794c7bdaabb558d081/dist/angular-datepicker.min.css']
});


// Drag & Drop
export const animatronDragDropSvc = () => Promise.all([require.ensure([], () => {
    require('./drag-drop/DragDropSvc');
    return {
        name: 'animatronApp.DragDropSvc',
        files: []
    };
})]);

export const animatronDropZone = () => Promise.all([require.ensure([], () => {
    require('./drag-drop/DropZone');
    return {
        name: 'animatronApp.DropZone',
        files: []
    };
}), animatronDragDropSvc()]);

export const animatronDragItem = () => Promise.all([require.ensure([], () => {
    require('./drag-drop/DragItem');
    return {
        name: 'animatronApp.DragItem',
        files: [getCss('drag-drop/drag-item')]
    };
}), animatronDragDropSvc()]);
// Drag & Drop end

// subscription
export const animatronSubscriptionCouponMessagesSvc = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/messages/SubscriptionCouponMessagesSvc');
    return {
        name: 'animatronApp.SubscriptionCouponMessagesSvc',
        files: []
    };
})]);

export const animatronSubscriptionMessagesSvc = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/messages/SubscriptionMessagesSvc');
    return {
        name: 'animatronApp.SubscriptionMessagesSvc',
        files: []
    };
})]);

export const animatronSubscriptionMessages = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/messages/SubscriptionMessages');
    return {
        name: 'animatronApp.SubscriptionMessages',
        files: [getCss('settings/subscription/messages/subscription-messages')]
    };
}), animatronSubscriptionMessagesSvc()]);

export const animatronSubscriptionSvc = () => Promise.all([require.ensure([], () => {
    require('./settings/services/SubscriptionSvc');
    return {
        name: 'animatronApp.SubscriptionSvc',
        files: []
    };
})]);

export const animatronSubscriptionPredictPrice = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/containers/SubscriptionPredictPriceContainer');
    return {
        name: 'animatronApp.SubscriptionPredictPriceContainer',
        files: []
    };
}),
    animatronSubscriptionSvc(),
    animatronSubscriptionTotalPrice(),
    animatronSubscriptionCreditInfo(),
    animatronSubscriptionCouponMessagesSvc()
]);

export const animatronSubscriptionCreditInfo = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/SubscriptionCreditInfo');
    return {
        name: 'animatronApp.SubscriptionCreditInfo',
        files: [getCss('settings/subscription/subscription-credit-info')]
    };
})]);

export const animatronSubscriptionTotalPrice = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/SubscriptionTotalPrice');
    return {
        name: 'animatronApp.SubscriptionTotalPrice',
        files: [getCss('settings/subscription/subscription-total-price')]
    };
})]);

export const animatronSubscriptionAlert = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/SubscriptionAlert');
    return {
        name: 'animatronApp.SubscriptionAlert',
        files: [getCss('settings/subscription/subscription-alert')]
    };
})]);

export const animatronSubscriptionBillingInfoForm = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/SubscriptionBillingInfoForm');
    return {
        name: 'animatronApp.SubscriptionBillingInfoForm',
        files: [getCss('settings/subscription/subscription-billing-info-form')]
    };
})]);

export const animatronSubscriptionCurrentPlan = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/SubscriptionCurrentPlan');
    return {
        name: 'animatronApp.SubscriptionCurrentPlan',
        files: [getCss('settings/subscription/subscription-current-plan')]
    };
})]);

export const animatronSubscriptionInvoiceHistoryTable = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/SubscriptionInvoiceHistoryTable');
    return {
        name: 'animatronApp.SubscriptionInvoiceHistoryTable',
        files: [getCss('settings/subscription/subscription-invoice-history-table')]
    };
})]);

export const animatronSubscriptionTitle = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/SubscriptionTitle');
    return {
        name: 'animatronApp.SubscriptionTitle',
        files: [getCss('settings/subscription/subscription-title')]
    };
})]);

export const animatronSubscriptionPaymentDetailsEnterCard = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/payment-details/SubscriptionPaymentDetailsEnterCard');
    return {
        name: 'animatronApp.SubscriptionPaymentDetailsEnterCard',
        files: [getCss('settings/subscription/payment-details/subscription-payment-details-enter-card')]
    };
})]);

export const animatronSubscriptionPaymentDetailsWithCard = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/payment-details/SubscriptionPaymentDetailsWithCard');
    return {
        name: 'animatronApp.SubscriptionPaymentDetailsWithCard',
        files: [getCss('settings/subscription/payment-details/subscription-payment-details-with-card')]
    };
})]);

export const animatronSubscriptionRouterModalsContainer = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/containers/SubscriptionRouterModalsContainer');
    return {
        name: 'animatronApp.SubscriptionRouterModalsContainer',
        files: [getCss('settings/subscription/containers/subscription-router-modals-container')]
    };
})]);

export const animatronSubscriptionCurrentPlanContainer = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/containers/SubscriptionCurrentPlanContainer');
    return {
        name: 'animatronApp.SubscriptionCurrentPlanContainer',
        files: [getCss('settings/subscription/containers/subscription-current-plan-container')]
    };
}),
    animatronSubscriptionAlert(),
    animatronSubscriptionTitle(),
    animatronSubscriptionCurrentPlan(),
    animatronSubscriptionPaymentDetailsContainer()
]);

export const animatronSubscriptionInvoiceHistoryContainer = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/containers/SubscriptionInvoiceHistoryContainer');
    return {
        name: 'animatronApp.SubscriptionInvoiceHistoryContainer',
        files: [getCss('settings/subscription/containers/subscription-invoice-history-container')]
    };
}),
    animatronSubscriptionTitle(),
    animatronSubscriptionInvoiceHistoryTable()
]);

export const animatronSubscriptionPaymentDetailsContainer = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/containers/SubscriptionPaymentDetailsContainer');
    return {
        name: 'animatronApp.SubscriptionPaymentDetailsContainer',
        files: [getCss('settings/subscription/containers/subscription-payment-details-container')]
    };
}),
    animatronSubscriptionTitle(),
    animatronSubscriptionPaymentDetailsEnterCard(),
    animatronSubscriptionPaymentDetailsWithCard()
]);

export const animatronSubscriptionPage = () => Promise.all([require.ensure([], () => {
    require('./settings/subscription/SubscriptionPage');
    return {
        name: 'animatronApp.SubscriptionPage',
        files: [getCss('settings/subscription/subscription-page')]
    };
}),
    animatronUpgrade(),
    animatronSubscriptionMessages(),
    animatronSubscriptionCurrentPlanContainer(),
    animatronSubscriptionPredictPrice(),
    animatronSubscriptionRouterModalsContainer(),
    animatronSubscriptionInvoiceHistoryContainer()
]);

// subscription end

// video folder
export const animatronVideoFolderMasonrySvc = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/masonry/VideoFolderMasonrySvc');
    return {
        name: 'animatronApp.VideoFolderMasonrySvc',
        files: []
    };
})]);

export const animatronVideoFolderMasonryItem = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/masonry/VideoFolderMasonryItem');
    return {
        name: 'animatronApp.VideoFolderMasonryItem',
        files: []
    };
}), animatronVideoFolderMasonrySvc()]);

export const animatronVideoFolderMasonry = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/masonry/VideoFolderMasonry');
    return {
        name: 'animatronApp.VideoFolderMasonry',
        files: [getCss('wave/folder/masonry/video-folder-masonry')]
    };
}), animatronVideoFolderMasonryItem(), animatronVideoFolderMasonrySvc()]);

export const animatronVideoFolderItem = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/VideoFolderItem');
    return {
        name: 'animatronApp.VideoFolderItem',
        files: [getCss('wave/folder/video-folder-item')]
    };
}), animatronVideoFolderBottom()]);

export const animatronVideoFolderName = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/VideoFolderName');
    return {
        name: 'animatronApp.VideoFolderName',
        files: []
    };
})]);

export const animatronVideoFolderControls = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/VideoFolderControls');
    return {
        name: 'animatronApp.VideoFolderControls',
        files: []
    };
}), animatronVideoFolderCreateNew()]);

export const animatronVideoFolderCreateNew = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/VideoFolderCreateNew');
    return {
        name: 'animatronApp.VideoFolderCreateNew',
        files: []
    };
})]);

export const animatronVideoFolderBottom = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/VideoFolderBottom');
    return {
        name: 'animatronApp.VideoFolderBottom',
        files: [getCss('wave/folder/video-folder-bottom')]
    };
}), animatronVideoFolderMoveModalSvc(), animatronVideoFolderName()]);

export const animatronVideoFolderMoveModalSvc = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/VideoFolderMoveModalSvc');
    return {
        name: 'animatronApp.VideoFolderMoveModalSvc',
        files: []
    };
})]);

export const animatronVideoFolderMoveModal = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/VideoFolderMoveModal');
    return {
        name: 'animatronApp.VideoFolderMoveModal',
        files: [getCss('wave/folder/video-folder-move-modal')]
    };
}),
    animatronVideoFolderTreeItem(),
    animatronVideoFolderCreateNew(),
    animatronVideoFolderMoveModalSvc()
]);

export const animatronVideoFolderBreadcrumb = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/VideoFolderBreadcrumb');
    return {
        name: 'animatronApp.VideoFolderBreadcrumb',
        files: [getCss('wave/folder/video-folder-breadcrumb')]
    };
})]);

export const animatronVideoFolderTreeItem = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/folder/VideoFolderTreeItem');
    return {
        name: 'animatronApp.VideoFolderTreeItem',
        files: [getCss('wave/folder/video-folder-tree-item')]
    };
}), animatronVideoFolderMoveModalSvc(), animatronVideoFolderName()]);
// video folder END

export const animatronTitleBlock = () => require.ensure([], () => {
    require('./landing-template/components/TitleBlock');
    return {
        name: 'animatronApp.titleBlock',
        files: [getCss('landing-template/components/title-block')]
    };
});

export const animatronRelationList = () => require.ensure([], () => {
    require('./landing-template/components/RelationList');
    return {
        name: 'animatronApp.relationList',
        files: [getCss('landing-template/components/relation-list')]
    };
});

export const animatronButtonStart = () => require.ensure([], () => {
    require('./landing-template/components/ButtonStart');
    return {
        name: 'animatronApp.buttonStart',
        files: []
    };
});

export const animatronBackground = () => require.ensure([], () => {
    require('./landing-template/components/Background');
    return {
        name: 'animatronApp.background',
        files: [getCss('landing-template/components/background')]
    };
});

export const animatronIconTextList = () => require.ensure([], () => {
    require('./landing-template/components/IconTextList');
    return {
        name: 'animatronApp.iconTextList',
        files: [getCss('landing-template/components/icon-text-list')]
    };
});

// contest landing
export const animatronContestLandingSvc = () => require.ensure([], () => {
    require('./contest-landing/ContestLandingSvc');
    return {
        name: 'animatronApp.contestLandingSvc',
        files: []
    };
});

export const animatronChallengesList = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ChallengesList');
    return {
        name: 'animatronApp.challengesList',
        files: [getCss('contest-landing/challenges-list')]
    };
}), wistiaPlayer(), animatronContestGoChallengeButton(), animatronContestLandingSvc()]);

export const animatronJudgeItem = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/JudgeItem');
    return {
        name: 'animatronApp.judgeItem',
        files: [getCss('contest-landing/judge-item')]
    };
})]);

export const animatronContestGoChallengeButton = () => require.ensure([], () => {
    require('./contest-landing/ContestGoChallengeButton');
    return {
        name: 'animatronApp.contestGoChallengeButton',
        files: []
    };
});

export const animatronCountdown = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/Countdown');
    return {
        name: 'animatronApp.countdown',
        files: [getCss('contest-landing/countdown')]
    };
})]);

export const animatronPreRegister = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/PreRegister');
    return {
        name: 'animatronApp.preRegister',
        files: [getCss('contest-landing/pre-register')]
    };
})]);

export const animatronSpreadInSocial = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/SpreadInSocial');
    return {
        name: 'animatronApp.spreadInSocial',
        files: [getCss('contest-landing/spread-in')]
    };
}),
    animatronTwitterShareButton(),
    animatronFacebookShareButton(),
    animatronLinkedinShareButton(),
    animatronGoogleShareButton(),
]);

export const animatronSponsorContactUs = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/SponsorContactUs');
    return {
        name: 'animatronApp.sponsorContactUs',
        files: [getCss('contest-landing/sponsor-contact-us')]
    };
})]);

export const animatronTitleShadowBlock = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/TitleShadowBlock');
    return {
        name: 'animatronApp.titleShadowBlock',
        files: [getCss('contest-landing/title-shadow-block')]
    };
})]);

export const animatronParticipateSteps = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ParticipateSteps');
    return {
        name: 'animatronApp.ParticipateSteps',
        files: [getCss('contest-landing/participate-steps')]
    };
})]);

export const animatronVideoImproveSteps = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/VideoImproveSteps');
    return {
        name: 'animatronApp.videoImproveSteps',
        files: [getCss('contest-landing/video-improve-steps')]
    };
}), animatronBackground()]);

export const animatronWinPrizesList = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/WinPrizesList');
    return {
        name: 'animatronApp.winPrizesList',
        files: [getCss('contest-landing/win-prizes-list')]
    };
})]);

export const animatronWinPrizesSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/WinPrizesSection');
    return {
        name: 'animatronApp.winPrizesSection',
        files: [getCss('contest-landing/win-prizes-section')]
    };
}), animatronTitleShadowBlock(), animatronContestLandingSvc()]);

export const animatronCountdownSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/CountdownSection');
    return {
        name: 'animatronApp.countdownSection',
        files: [getCss('contest-landing/countdown-section')]
    };
}), animatronCountdown(), animatronTitleBlock(), animatronBackground()]);

export const animatronContestDaysTopSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ContestDaysTopSection');
    return {
        name: 'animatronApp.contestDaysTopSection',
        files: [getCss('contest-landing/contest-days-top-section')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronContestGoChallengeButton()]);

export const animatronContactUsSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ContactUsSection');
    return {
        name: 'animatronApp.contactUsSection',
        files: [getCss('contest-landing/contact-us-section')]
    };
}),
    animatronBackground(),
    animatronPreRegister(),
    animatronSponsorContactUs(),
    animatronSpreadInSocial()
]);

export const animatronPreRegisterSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/PreRegisterSection');
    return {
        name: 'animatronApp.preRegisterSection',
        files: [getCss('contest-landing/pre-register-section')]
    };
}), animatronPreRegister(), animatronBackground()]);

export const animatronMediaSponsorsSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/MediaSponsorsSection');
    return {
        name: 'animatronApp.mediaSponsorsSection',
        files: [getCss('contest-landing/media-sponsors-section')]
    };
})]);

export const animatronChallengesListSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ChallengesListSection');
    return {
        name: 'animatronApp.challengesListSection',
        files: [getCss('contest-landing/challenges-list-section')]
    };
}),
    animatronTitleShadowBlock(),
    animatronChallengesList(),
    wistiaPlayer(),
    animatronTitleShadowBlock(),
    animatronContestLandingSvc(),
    animatronContestGoChallengeButton(),
]);

export const animatronContestTextVideoSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ContestTextVideoSection');
    return {
        name: 'animatronApp.contestTextVideoSection',
        files: [getCss('contest-landing/contest-text-video-section')]
    };
}), wistiaPlayer(), animatronContestGoChallengeButton()]);

export const animatronVideoImproveStepsSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/VideoImproveStepsSection');
    return {
        name: 'animatronApp.videoImproveStepsSection',
        files: [getCss('contest-landing/video-improve-steps-section')]
    };
}), animatronVideoImproveSteps(), animatronTitleShadowBlock(), animatronBackground(), wistiaPlayer()]);

export const animatronContestLanding = () => Promise.all<any>([require.ensure([], () => {
    require('./contest-landing/ContestLanding');
    return {
        name: 'animatronApp.contestLanding',
        files: [getCss('contest-landing/contest-landing')]
    };
}),
    animatronWinPrizesSection(),
    animatronCountdownSection(),
    animatronContactUsSection(),
    animatronContestLandingSvc(),
    animatronPreRegisterSection(),
    animatronMediaSponsorsSection(),
    animatronChallengesListSection(),
    animatronContestDaysTopSection(),
    animatronContestTextVideoSection(),
    animatronVideoImproveStepsSection()
]);

export const animatronContestDays = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ContestDays');
    return {
        name: 'animatronApp.contestDays',
        files: [getCss('contest-landing/contest-days')]
    };
}),
    animatronJudgeItem(),
    animatronWinPrizesSection(),
    animatronContactUsSection(),
    animatronParticipateSteps(),
    animatronPreRegisterSection(),
    animatronMediaSponsorsSection(),
    animatronContestDaysTopSection(),
    animatronContestTextVideoSection(),
]);
// END contest components

export const animatronDifferentDevices = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/DifferentDevices');
    return {
        name: 'animatronApp.differentDevices',
        files: [getCss('landing-template/components/different-devices')]
    };
})]);

export const animatronTemplatePagesListItem = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/TemplatePagesListItem');
    return {
        name: 'animatronApp.templatePagesListItem',
        files: [getCss('landing-template/components/template-pages-list-item')]
    };
}), animatronBackground()]);

export const animatronTemplatePagesList = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/TemplatePagesList');
    return {
        name: 'animatronApp.templatePagesList',
        files: [getCss('landing-template/components/template-pages-list')]
    };
}), animatronTemplatePagesListItem()]);

export const animatronSectionTemplatePagesList = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionTemplatePagesList');
    return {
        name: 'animatronApp.sectionTemplatePagesList',
        files: [getCss('landing-template/components/sections/section-template-pages-list')]
    };
}), animatronTemplatePagesList()]);

export const animatronSectionBackgroundText = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionBackgroundText');
    return {
        name: 'animatronApp.sectionBackgroundText',
        files: [getCss('landing-template/components/sections/section-background-text')]
    };
}), animatronTitleBlock(), animatronBackground()]);

export const animatronSectionBitmap = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionBitmap');
    return {
        name: 'animatronApp.sectionBitmap',
        files: [getCss('landing-template/components/sections/section-bitmap')]
    };
}), animatronTitleBlock()]);

export const animatronSectionFeedback = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionFeedback');
    return {
        name: 'animatronApp.sectionFeedback',
        files: [getCss('landing-template/components/sections/section-feedback')]
    };
}), animatronTitleBlock(), animatronFeedback()]);

export const animatronSectionHorizontalTextVideo = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionHorizontalTextVideo');
    return {
        name: 'animatronApp.sectionHorizontalTextVideo',
        files: [getCss('landing-template/components/sections/section-horizontal-text-video')]
    };
}), animatronTitleBlock(), animatronButtonStart(), wistiaPlayer()]);

export const animatronSectionHorizontalImageText = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionHorizontalImageText');
    return {
        name: 'animatronApp.sectionHorizontalImageText',
        files: [getCss('landing-template/components/sections/section-horizontal-image-text')]
    };
}), animatronTextBlock(), animatronButtonStart(), animatronBackground()]);

export const animatronSectionVerticalTextVideo = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVerticalTextVideo');
    return {
        name: 'animatronApp.sectionVerticalTextVideo',
        files: [getCss('landing-template/components/sections/section-vertical-text-video')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronButtonStart(), wistiaPlayer()]);

export const animatronSectionDifferentDevices = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionDifferentDevices');
    return {
        name: 'animatronApp.sectionDifferentDevices',
        files: [getCss('landing-template/components/sections/section-different-devices')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronDifferentDevices(), animatronButtonStart()]);

export const animatronSectionCompanyInfo = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionCompanyInfo');
    return {
        name: 'animatronApp.sectionCompanyInfo',
        files: [getCss('landing-template/components/sections/section-company-info')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronIconTextList()]);

export const animatronSectionVideoStatistics = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVideoStatistics');
    return {
        name: 'animatronApp.sectionVideoStatistics',
        files: [getCss('landing-template/components/sections/section-video-statistics')]
    };
}), animatronTitleBlock(), animatronDoubleCircleProgress()]);

export const animatronSectionCompanyQuote = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionCompanyQuote');
    return {
        name: 'animatronApp.sectionCompanyQuote',
        files: [getCss('landing-template/components/sections/section-company-quote')]
    };
}), animatronBackground()]);

export const animatronSectionTextAside = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionTextAside');
    return {
        name: 'animatronApp.sectionTextAside',
        files: [getCss('landing-template/components/sections/section-text-aside')]
    };
}), animatronTitleBlock(), animatronRelationList()]);

export const animatronSectionSignUp = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionSignUp');
    return {
        name: 'animatronApp.sectionSignUp',
        files: [getCss('landing-template/components/sections/section-sign-up')]
    };
}), animatronBackground(), animatronSignUpBlock(), animatronTextBlock()]);

export const animatronSectionLogoVideoSignUp = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionLogoVideoSignUp');
    return {
        name: 'animatronApp.sectionLogoVideoSignUp',
        files: [getCss('landing-template/components/sections/section-logo-video-sign-up')]
    };
}), animatronTextBlock(), animatronBackground(), animatronSignUpBlock()]);

export const animatronSectionVideoSignUp = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVideoSignUp');
    return {
        name: 'animatronApp.sectionVideoSignUp',
        files: [getCss('landing-template/components/sections/section-video-sign-up')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronSignUpBlock(), scrollButton()]);

export const animatronSectionVideoTime = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVideoTime');
    return {
        name: 'animatronApp.sectionVideoTime',
        files: [getCss('landing-template/components/sections/section-video-time')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronButtonStart(), wistiaPlayer(), scrollButton()]);

export const animatronSectionVideoGallery = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVideoGallery');
    return {
        name: 'animatronApp.sectionVideoGallery',
        files: [getCss('landing-template/components/sections/section-video-gallery')]
    };
}), animatronTitleBlock(), animatronVideoGallery(), animatronButtonStart()]);

export const animatronSectionVideoSteps = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVideoSteps');
    return {
        name: 'animatronApp.sectionVideoSteps',
        files: [getCss('landing-template/components/sections/section-video-steps')]
    };
}), animatronTitleBlock(), videoSteps(), animatronButtonStart()]);

export const animatronLandingTemplate: any = () => Promise.all<any>([require.ensure([], () => {
    require('./landing-template/LandingTemplate');
    return {
        name: 'animatronApp.landingTemplate',
        files: [
            getCss('landing-template/landing-template')
        ]
    };
}),
    animatronSectionTemplatePagesList(),
    animatronSectionBackgroundText(),
    animatronSectionLogoVideoSignUp(),
    animatronSectionVideoSignUp(),
    animatronSectionVideoStatistics(),
    animatronSectionVideoTime(),
    animatronSectionBitmap(),
    animatronSectionHorizontalTextVideo(),
    animatronSectionCompanyInfo(),
    animatronSectionHorizontalImageText(),
    animatronSectionTextAside(),
    animatronSectionCompanyQuote(),
    animatronSectionDifferentDevices(),
    animatronSectionVerticalTextVideo(),
    animatronSectionVideoGallery(),
    animatronSectionSignUp(),
    animatronSectionFeedback(),
    animatronSectionVideoSteps()
]);

const userInfoForm = () => new Promise<oc.IModuleConfig[]>(resolve => {
    require.ensure([], () => {
        require('./directives/UserInfoForm');
        resolve([{
            name: 'animatronApp.userInfoForm',
            files: [
                getCss('user-info-form'),
                getCss('dropdown-menu'),
                getCss('newsWebsite'),
                getCss('_checkbox')
            ]
        }, angularMessages]);
    });
});

export const bgVideoSlider = () => Promise.all([require.ensure([], () => {
    require('./directives/bgVideoSlider');
    return {
        name: 'animatronApp.bgVideoSlider',
        files: []
    };
}), bgVideo()]);

export const modalVideoPlayer = () => Promise.all([require.ensure([], () => {
    require('./directives/modalVideoPlayer');
    return {
        name: 'animatronApp.modalVideoPlayer',
        files: [getCss('modal-video-player')]
    };
}), videoPlayer()]);

export const mainLanding = () => Promise.all([require.ensure([], () => {
    require('./directives/mainLanding');
    return {
        name: 'animatronApp.mainLanding',
        files: [
            getCss('landing/any-landing'),
            options.handHeld ? getCss('mobile/m-any-landing') : ''
        ]
    };
})]);

export const tagsInput = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('ng-tags-input.js');
        resolve({name: 'ngTagsInput', files: [getCss('ng-tags-input')]});
    });
});

export const scrollFixedElement = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('./directives/scrollFixedElementDirective');
        resolve({name: 'animatronApp.scrollFixedElement', files: []});
    });
});

export const waveUserPage = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveUserPage');
    return {
        name: 'animatronApp.waveUserPage',
        files: [getCss('wave/wave-user-page')]
    };
}), waveProjects(), animatronVideoFolderBreadcrumb()]);

export const bgVideo = () => require.ensure([], () => {
    require('./directives/bgVideo');
    return {
        name: 'animatronApp.bgVideo',
        files: [getCss('bg-video')]
    };
});

export const scrollButton = () => require.ensure([], () => {
    require('./directives/scrollButton');
    return {
        name: 'animatronApp.scrollButton',
        files: [getCss('scroll-button')]
    };
});

export const ytPlayer = () => require.ensure([], () => {
    require('./directives/ytPlayer');
    return {
        name: 'animatronApp.ytPlayer',
        files: []
    };
});

export const videoPlayer = () => require.ensure([], () => {
    require('./directives/videoPlayer');
    return {
        name: 'animatronApp.videoPlayer',
        files: [getCss('video-player')]
    };
});


export const wistiaPlayer = () => require.ensure([], () => {
    require('./directives/wistiaPlayer');
    return {
        name: 'animatronApp.wistiaPlayer',
        files: [getCss('wistia-player')]
    };
});

export const videoSlider = () => Promise.all([require.ensure([], () => {
    require('./directives/videoSlider');
    return {
        name: 'animatronApp.videoSlider',
        files: [getCss('video-slider')]
    };
}), videoPlayer()]);

const ticker = () => new Promise(resolve => {
    require.ensure([], () => {
        require('./services/Ticker');
        resolve({name: 'animatronApp.ticker', files: []});
    });
});

const animatronRandomNumber = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('./directives/randomFact');
        resolve({
            name: 'animatronApp.randomFact',
            files: [getCss('settings/random-fact')]
        });
    });
});

export const animatronUpgrade = () => Promise.all([new Promise<oc.IModuleConfig[]>(resolve => {
    try { angular.module('animatronApp.settings'); } catch (e) { angular.module('animatronApp.settings', []); }

    require.ensure([], () => {
        require('./settings/directives/Subscriptions');
        require('./settings/directives/stripeFormDirective');
        require('./settings/directives/securePaymentDirective');
        require('./settings/directives/couponDirective');
        require('./settings/directives/upgradePlanDirective');
        require('./settings/directives/subscriptionPriceBlock');
        require('./settings/directives/subscriptionTypes');
        require('./settings/directives/infoAppSumo');
        require('./settings/directives/subscriptionPlanDirective');
        require('./directives/PlanAnimation');
        require('./settings/services/TypeformSvc');
        resolve([{
            name: 'animatronApp.settings',
            files: [getCss('settings')]
        }, {name: 'animatronApp.planAnimation', files: []}]);
    });
}), animatronSubscriptionSvc()]);

export const animatronSettings = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        try {angular.module('animatronApp.settings');} catch (e) {angular.module('animatronApp.settings', []);}
        require('./settings/controllers/SettingsCtrl');
        require('./settings/controllers/ProfileCtrl');
        require('./settings/controllers/PasswordCtrl');
        require('./settings/controllers/NotificationCtrl');
        require('./settings/directives/deleteAccount');
        require('./settings/directives/avatarUploadDirective');
        require('./settings/directives/AddressDirective');
        resolve({
            name: 'animatronApp.settings',
            files: [
                getCss('tabs'),
                getCss('newsWebsite')
            ]
        });
    });
}), animatronRandomNumber(), animatronUpgrade(), userInfoForm(), animatronSubscriptionTitle(), animatronUserNotification()]);

export const animatronTutorial = () => new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.tutorial', []);
        require('tutorial.html');
        require('tutorials/tutorial-video.html');
        require('./directives/TutorialComponent');
        require('./directives/TutorialModal');
        require('./services/TutorialSvc');
        require('./directives/tutorialVideoDirective');
        require('./directives/youtubeModalDirective');
        resolve({
            name: 'animatronApp.tutorial',
            files: [
                getCss('tutorial'),
                getCss('tabs'),
                getCss('search')
            ]
        });
    });
});

export const animatronSpecialUpgrade = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        try {angular.module('animatronApp.settings');} catch (e) {angular.module('animatronApp.settings', []);}
        require('./directives/SpecialUpgrade');
        resolve({
            name: 'animatronApp.special-upgrade',
            files: [getCss('special-upgrade')]
        });
    });
}), animatronSubscriptionPage(), animatronSubscriptionPaymentDetailsContainer()]);

export const animatronFeedback = () => require.ensure([], () => {
    try {angular.module('animatronApp.feedback');} catch (e) {angular.module('animatronApp.feedback', []);}

    require('./directives/randomFeedbackDirective');
    require('./directives/feedbackSlider');
    require('./directives/FeedbackSwipable');
    require('./directives/feedbacksListDirective');
    require('./services/OurFeedbackSvc');

    return {
        name: 'animatronApp.feedback',
        files: [getCss('feedback-slider')]
    };
});

export const animatronEdu = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.education', []);
        require('./directives/EducationComponent');
        require('./directives/eduExampleProject');
        require('education/education.html');
        resolve({
            name: 'animatronApp.education',
            files: [
                getCss('edu'),
                getCss('signup')
            ]
        });
    });
}), animatronTutorial()]);

export const animatronPrivacy = [getCss('tutorial')];
export const animatronTermsServices = [getCss('tutorial')];

export const pricingSubscription = () => require.ensure([], () => {
    require('./directives/pricingSubscriptionDirective');
    return {
        name: 'animatronApp.pricingSubscription',
        files: []
    };
});

export const animatronPricing = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.pricing', []);
        require('./directives/PlanAnimation');
        resolve([{
            name: 'animatronApp.pricing',
            files: [
                getCss('pricing'),
                options.handHeld ? getCss('mobile/m-landing-bottom') : ''
            ]
        }, {name: 'animatronApp.planAnimation', files: []}]);
    });
}), animatronFeedback(), pricingSubscription(), animatronSubscriptionPage(), animatronSubscriptionPage()]);

export const wavePricing = () => Promise.all([require.ensure([], () => {
    angular.module('animatronApp.wavePricing', []);
    require('./wave/wavePricing');

    return {
        name: 'animatronApp.wavePricing',
        files: [
            getCss('wave/wave-pricing'),
            options.handHeld ? getCss('mobile/wave/m-wave-pricing') : ''
        ]
    };
}), pricingSubscription(), animatronSubscriptionPage()]);

const animatronCanvas = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('./landing_bottom/animatronCanvas');
        resolve({name: 'animatronApp.animatronCanvas', files: []});
    });
});

export const animatronVideoGallery = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('./directives/landing/VideoGallery');
        resolve({
            name: 'animatronApp.videoGallery',
            files: [
                getCss('landing/video-gallery')
            ]
        });
    });
});

export const animatronExplainerGallery = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('./directives/landing/ExplainerGallery');
        resolve({name: 'animatronApp.explainerGallery', files: [getCss('landing/masonry-wrapper')]});
    });
});

export const animatronSignup = () => new Promise<oc.IModuleConfig[]>(resolve => {
    require.ensure([], () => {
        require('./directives/signupFormDirective');
        resolve([angularMessages, {
            name: 'animatronApp.signup',
            files: [
                // getHtml('signup/sign-up'),
                getCss('signup'),
                getCss('sign-up-block')
            ]
        }]);
    });
});

export const introduceVideo = () => require.ensure([], () => {
    require('./directives/introduceVideo');
    return {
        name: 'animatronApp.introduce-video',
        files: []
    };
});

export const animatronBannerBottom = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.bannerBottom', []);
        require('./directives/landing/LandingSignup');
        require('./directives/landing/BannerGallery');
        require('./landing_bottom/PlayerPlayOnMouse');
        resolve({
            name: 'animatronApp.bannerBottom',
            files: [
                getCss('landing/banner-bottom'),
                options.handHeld ? getCss('mobile/m-landing-banner') : ''
            ]
        });
    });
}), animatronFeedback(), animatronCanvas(), animatronVideoGallery()]);


export const animatronMediumLanding = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.mediumLanding', []);
        require('./directives/landing/MediumLanding');
        resolve({
            name: 'animatronApp.mediumLanding',
            files: [
                getCss('landing/medium-landing'),
                options.handHeld && getCss('mobile/m-medium-landing')
            ]
        });
    });
}), animatronCanvas(), animatronVideoGallery(), bgVideo(), videoSlider(), animatronFeedback()]);

export const animatronComparisonBottom = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.comparisonBottom', []);
        resolve({
            name: 'animatronApp.comparisonBottom',
            files: [
                getCss('landing/comparison'),
                options.handHeld ? getCss('mobile/m-landing-comparison') : '',
                getCss('tabs')
            ]
        });
    });
}), scrollFixedElement()]);

export const animatronLandingNewBottom = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.landingNewBottom', []);
        require('./directives/landing/LaptopVideo');
        require('./directives/landing/LandingGallery');
        require('landing/landing-new-bottom.html');
        require('landing/feedback-swipable.html');
        resolve({
            name: 'animatronApp.landingNewBottom',
            files: [
                getCss('landing/masonry-wrapper'),
                getCss('tabs'),
                getCss('landing/landing-new-bottom')
            ]
        });
    });
}), ytPlayer(), animatronFeedback(), wistiaPlayer()]);

export const animatronExplainerBottom = animatronBannerBottom;

export const animatronTwitterFollowButton = () => require.ensure([], () => {
    require('./directives/twitterFollowButton');
    return {
        name: 'animatronApp.twitterFollowButton',
        files: []
    };
});

export const animatronTwitterShareButton = () => require.ensure([], () => {
    require('./directives/twitterShareButton');
    return {
        name: 'animatronApp.twitterShareButton',
        files: []
    };
});

export const animatronFacebookShareButton = () => require.ensure([], () => {
    require('./directives/facebookShareButton');
    return {
        name: 'animatronApp.facebookShareButton',
        files: [getCss('f_bsh-button')]
    };
});

export const animatronLinkedinShareButton = () => require.ensure([], () => {
    require('./directives/linkedinShareButton');
    return {
        name: 'animatronApp.linkedinShareButton',
        files: [getCss('le-share-button')]
    };
});

export const animatronGoogleShareButton = () => require.ensure([], () => {
    require('./directives/googleShareButton');
    return {
        name: 'animatronApp.googleShareButton',
        files: [getCss('go-share-button')]
    };
});

export const animatronUserNotification = () => require.ensure([], () => {
    require('./directives/notification/UserNotification');
    return {
        name: 'animatronApp.UserNotification',
        files: [getCss('notification/user-notification')]
    };
});

export const animatronSignUpBlock = () => require.ensure([], () => {
    require('./directives/signUpBlock');
    return [angularMessages, {
        name: 'animatronApp.signUpBlock',
        files: [getCss('sign-up-block')]
    }];
});

export const animatronDoubleCircleProgress = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/DoubleCircleProgress');
    return {
        name: 'animatronApp.doubleCircleProgress',
        files: [getCss('landing-template/components/double-circle-progress')]
    };
})]);

export const animatronTextBlock = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/TextBlock');
    return {
        name: 'animatronApp.textBlock',
        files: [getCss('landing-template/components/text-block')]
    };
}), animatronTitleBlock(), animatronButtonStart()]);

export const animatronCompany = () => Promise.all([require.ensure([], () => {
    require('./directives/company');
    return {
        name: 'animatronApp.company',
        files: [
            getCss('company'),
            options.handHeld ? getCss('mobile/m-company') : ''
        ]
    };
})]);

//editor redirect page
export const animatronEditorRedirect = () => Promise.all([require.ensure([], () => {
    require('./directives/editor-redirect');
    return {
        name: 'animatronApp.editorRedirect',
        files: [
            getCss('editor-redirect')
        ]
    };
}), animatronTwitterFollowButton()]);
//

export const animatronContractors = () => new Promise(resolve => {
    require.ensure([], () => {
        require('./directives/Contractors');
        resolve({
            name: 'animatronApp.contractors',
            files: [
                getCss('user-section'),
                getCss('contractors')
            ]
        });
    });
});

export const waveMain = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveLanding');
    return {
        name: 'animatronApp.wave.landing',
        files: [
            getCss('wave/wave-landing'),
            options.handHeld ? getCss('mobile/wave/m-wave-landing') : ''
        ]
    };
}), animatronVideoGallery(), bgVideo(), waveSectionHowWork()]);

export const waveLandingSMMW = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveLandingSMMW');
    return {
        name: 'animatronApp.wave.landingSMMW',
        files: [
            getCss('wave/wave-landing-smmw'),
            options.handHeld ? getCss('mobile/wave/m-wave-landing-smmw') : ''
        ]
    };
}), introduceVideo(), waveSectionHowWork(), scrollButton()]);

export const mariSmithTutorials = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/mariSmithTutorials');
    return {
        name: 'animatronApp.wave.mariSmithTutorials',
        files: [
            getCss('wave/wave-webinar'),
            options.handHeld ? getCss('mobile/wave/m-webinar') : ''
        ]
    };
})]);

export const salmaWebinars = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/salmaWebinars');
    return {
        name: 'animatronApp.wave.salmaWebinars',
        files: [
            getCss('wave/wave-webinar'),
            options.handHeld ? getCss('mobile/wave/m-webinar') : ''
        ]
    };
})]);

export const waveProject = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveProjectItem');
    return {
        name: 'animatronApp.wave.project-item',
        files: [getCss('wave/wave-project-item')]
    };
}), animatronVideoFolderBottom(), animatronVideoFolderMoveModalSvc()]);

export const waveTutorialWorkshops = () => require.ensure([], () => {
    require('./directives/wave/tutorial/TutorialWorkshops');
    return {
        name: 'animatronApp.wave.tutorialWorkshops',
        files: [getCss('wave/tutorial/wave-tutorial-workshops')]
    };
});

export const waveTutorialsItem = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/tutorial/TutorialsItem');
    return {
        name: 'animatronApp.wave.tutorialsItem',
        files: [getCss('wave/tutorial/wave-tutorials-item')]
    };
}), animatronTutorial()]);

export const waveTutorialsList = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/tutorial/TutorialsList');
    return {
        name: 'animatronApp.wave.tutorialsList',
        files: [getCss('wave/tutorial/wave-tutorials-list')]
    };
}), waveTutorialsItem()]);

export const waveTutorialPage = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/tutorial/TutorialPage');
    return {
        name: 'animatronApp.wave.tutorialPage',
        files: [getCss('wave/tutorial/wave-tutorial-page')]
    };
}), waveTutorialsList(), animatronSectionVerticalTextVideo(), waveTutorialWorkshops(), animatronSectionHorizontalImageText()]);


export const videoSteps = () => Promise.all([require.ensure([], () => {
    require('./directives/videoSteps');
    return {
        name: 'animatronApp.videoSteps',
        files: [getCss('video-steps')]
    };
}), animatronButtonStart(), wistiaPlayer()]);

export const waveSectionHowWork = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveSectionHowWork');
    return {
        name: 'animatronApp.wave.sectionHowWork',
        files: [getCss('wave/wave-section-how-work')]
    };
}), videoSteps()]);

export const waveTemplate = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveTemplateItem');
    return {
        name: 'animatronApp.wave.template-item',
        files: [getCss('wave/wave-template-item')]
    };
}), modalVideoPlayer()]);

export const waveProjects = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveProjects');
    return {
        name: 'animatronApp.wave.projects',
        files: [
            getCss('projects'),
            getCss('wave/wave-projects')
        ]
    };
}),
    waveProject(),
    animatronDragItem(),
    animatronDropZone(),
    animatronVideoFolderItem(),
    animatronVideoFolderCreateNew(),
    animatronVideoFolderMoveModal(),
    animatronVideoFolderMasonry()
]);

export const waveMyProjects = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveMyProjects');
    return {
        name: 'animatronApp.wave.my-projects',
        files: [
            getCss('tabs'),
            getCss('wave/wave-my-projects')
        ]
    };
}),
    waveProjects(),
    animatronVideoFolderBreadcrumb(),
    animatronVideoFolderControls()
]);

export const animatronActivate = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        require('./directives/activate/ActivateEmail');
        require('./directives/activate/ActivateOAuth');
        resolve([angularMessages, {
            name: 'animatronApp.activate',
            files: [
                getCss('activate')
            ]
        }]);
    });
}), userInfoForm()]);

export const animatronRecovery = () => new Promise<oc.IModuleConfig[]>(resolve => {
    require.ensure([], () => {
        require('./directives/recovery/RecoveryPage');
        resolve([angularMessages, {
            name: 'animatronApp.recovery',
            files: [getCss('activate')]
        }]);
    });
});

export const animatronRecoveryReset = () => new Promise<oc.IModuleConfig[]>(resolve => {
    require.ensure([], () => {
        require('./directives/recovery/RecoveryResetPage');
        resolve([angularMessages, {
            name: 'animatronApp.recoveryReset',
            files: [getCss('activate')]
        }]);
    });
});

export const animatronProjectAnalytics = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.projectAnalytics', []);
        require('./directives/analytics/ProjectAnalytics');
        require('./directives/analytics/viewsCountAnalyticsDirective');
        require('./directives/analytics/summarizedAnalyticsDirective');
        require('./directives/analytics/detailedViewsAnalyticsDirective');
        resolve({
            name: 'animatronApp.projectAnalytics',
            files: [
                'https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.16/d3.min.js', // consider https://plot.ly/javascript/
                getCss('settings'),
                getCss('analytics'),
                getCss('projects'),
                getCss('tabs'),
                getCss('dropdown-menu')
            ]
        });
    });
});

export const animatronThumbnailPicker = () => new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.thumbnailPicker', []);
        require('./directives/thumbnailPicker');
        resolve({
            name: 'animatronApp.thumbnailPicker',
            files: [getCss('thumbnail-picker')]
        });
    });
});

export const animatronPublish = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.publish', []);
        require('./directives/publishDirective');
        require('./directives/PublishVideo');
        resolve({
            name: 'animatronApp.publish',
            files: [
                getCss('publish'),
                getCss('tabs'),
                getCss('_checkbox')
            ]
        });
    });
}), ticker(), animatronThumbnailPicker()]);

export const animatronProjectPreviewPicker = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.projectPreviewPicker', []);
        require('./directives/projectPreviewPicker');
        resolve({
            name: 'animatronApp.projectPreviewPicker',
            files: [getCss('publish')]
        });
    });
}), animatronThumbnailPicker()]);

export const animatronProjects = () => new Promise<oc.IModuleConfig>(resolve => {
    angular.module('animatronApp.projects', []);
    resolve({
        name: 'animatronApp.projects',
        files: [
            getCss('tabs'),
            getCss('newsWebsite'),
            getCss('search')
        ].concat(animatronProject)
    });
});

export const animatronUserPage = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.profileProject', []);
        require('./directives/UserPage');
        require('./directives/FollowersPage');
        require('./services/FollowersSvc');
        require('./directives/profileProjectDirective');
        require('./directives/paginationDirective');
        resolve({
            name: 'animatronApp.profileProject',
            files: [getCss('user-section')]
        });
    });
}), animatronProjects()]);


export const animatronHtml5Offline = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.html5Offline', []);
        require('./directives/DownloadHtml5');
        resolve({
            name: 'animatronApp.html5Offline',
            files: [
                getCss('publish'),
                getCss('tabs'),
                getCss('_checkbox')
            ]
        });
    });
}), animatronThumbnailPicker()]);

//export const animatronSearchPage = [animatronProjects(), getJs('controllers/SearchPageCtrl')];
export const animatronSearchPage = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        require('./directives/SearchPage');
        resolve({
            name: 'animatronApp.searchPage',
            files: [
                getCss('search-page'),
                options.handHeld && getCss('mobile/m-search-page')
            ]
        });
    });
}), animatronProjects()]);

//FIXME might not work
export const animatronContest = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.contest', []);
        require('./contest/ContestPage');
        require('./contest/JoinContestsPage');
        require('./contest/MyContestsPage');
        require('./contest/InitiateContestPage');
        resolve({
            name: 'animatronApp.contest',
            files: [
                getCss('contest/contest'),
                getCss('_checkbox')
            ]
        });
    });
}), animatronUserPage(), datePicker()]);



// WEBPACK FOOTER //
// ./app/assets/javascripts/lazy_modules.ts